export default __webpack_public_path__ + "static/media/Abyssal Demon Pendant of Strength.7e7d4a47.jpg";